
import { faPawSimple, faRoute } from '@fortawesome/pro-solid-svg-icons'
import distance from '@turf/distance'

export default {
  name: 'PaddockNearest',

  props: {
    paddock: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      faPawSimple,
      faRoute
    }
  },

  computed: {
    compNearestPaddocks() {
      if (!this.paddock.id) {
        return []
      }

      const paddocks = this.$store.getters['paddocks/all']
        .filter(paddock => paddock.id !== this.paddock.id)
        .map(paddock => {
          const distanceMiles = distance(this.paddock.entranceCoordinates, paddock.entranceCoordinates, {
            units: 'miles'
          })

          return {
            ...paddock,
            distanceMiles: Math.round(distanceMiles)
          }
        })
        .sort((a, b) => a.distanceMiles - b.distanceMiles)

      return paddocks.slice(0, 3)
    }
  },

  methods: {
    findOutMorePaddock(paddock) {
      this.$emit('findOutMore', paddock)
    },

    viewAllPaddocks() {
      this.$emit('viewAllPaddocks')
    }
  }
}
